/**
 * Compacte kleed-tijdlijn: dezelfde stappen die kantoor en de agents zien
 * (office-app kleed-tijdlijn.ts). Oudste eerst. Bron 'tekst' en 'afgeleid'
 * (kloppen) staan gedempt: afgeleid uit het wasrapport of uit een veld,
 * niet als handeling vastgelegd.
 */
import type { TijdlijnStap } from '../lib/salesforce';

const fmt = new Intl.DateTimeFormat('nl-NL', {
  timeZone: 'Europe/Amsterdam', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false,
});

function moment(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return fmt.format(d).replace(',', '');
}

function kap(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

interface Props {
  stappen: TijdlijnStap[];
  className?: string;
}

export function KleedTijdlijnLijst({ stappen, className }: Props) {
  if (stappen.length === 0) return null;
  return (
    <ol className={['space-y-1.5', className].filter(Boolean).join(' ')}>
      {stappen.map((s, i) => {
        const gedempt = s.bron === 'tekst' || s.bron === 'afgeleid';
        const suffix = [
          s.methode,
          s.reden && s.fase !== 'geklopt' && !s.label.startsWith('afgekeurd') ? `reden: ${s.reden}` : null,
          s.fotos ? `${s.fotos} foto's` : null,
          s.medewerker,
        ].filter(Boolean).join(', ');
        return (
          <li key={`${s.moment}-${s.fase}-${i}`} className={gedempt ? 'text-wb-inkt3' : 'text-wb-inkt'}>
            <div className="flex items-baseline gap-2 text-sm">
              <span className="font-mono text-xs text-wb-inkt2 shrink-0 w-[88px]">{moment(s.moment)}</span>
              <span className="font-semibold">{kap(s.label)}</span>
              {suffix && <span className="text-xs text-wb-inkt2">{suffix}</span>}
            </div>
            {s.notitie && <p className="pl-[96px] text-xs text-wb-inkt2 whitespace-pre-wrap">{s.notitie}</p>}
          </li>
        );
      })}
    </ol>
  );
}
